import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';
import { getImagesByQuery } from './js/pixabay-api';
import {
  clearGallery,
  createGallery,
  hideLoader,
  showLoader,
} from './js/render-functions';

const imgInput = document.querySelector('.search-input');
const searchForm = document.querySelector('.form');
const loadMoreBtn = document.querySelector('.load-more-btn');

imgInput.addEventListener('focus', () => {
  imgInput.value = '';
});

let page = 1;
let totalHits = 0;
const perPage = 15;
let currentQuery = '';

searchForm.addEventListener('submit', async event => {
  event.preventDefault();

  const query = imgInput.value.trim();

  if (query === '') {
    return;
  }

  page = 1;
  currentQuery = query;
  loadMoreBtn.classList.add('hidden');

  clearGallery();
  showLoader();

  try {
    const data = await getImagesByQuery(query, page);
    totalHits = data.totalHits;

    if (data.hits.length === 0) {
      iziToast.error({
        title: '❌',
        message: `Sorry, there are no images matching your search query. Please try again!`,
        position: 'topRight',
        timeout: '2000',
      });
      return;
    }

    createGallery(data.hits);

    if (totalHits > perPage) {
      loadMoreBtn.classList.remove('hidden');
    } else {
      iziToast.info({
        title: '❌',
        message: "We're sorry, but you've reached the end of search results.",
        position: 'topRight',
        timeout: 2000,
      });
    }
  } catch (error) {
    console.log(error);
    iziToast.error({
      title: 'Error',
      message: `Something went wrong with the server request. Please try again later.!`,
      position: 'topRight',
      timeout: '2000',
    });
  } finally {
    hideLoader();
  }
});

async function handleLoadMoreClick() {
  loadMoreBtn.classList.add('hidden');
  showLoader();
  page += 1;

  try {
    const images = await getImagesByQuery(currentQuery, page);
    createGallery(images.hits);

    const loadedImg = page * perPage;

    if (loadedImg >= totalHits) {
      iziToast.info({
        title: '❌',
        message: "We're sorry, but you've reached the end of search results.",
        position: 'topRight',
        timeout: 2000,
      });
      loadMoreBtn.classList.add('hidden');
    } else {
      loadMoreBtn.classList.remove('hidden');
    }

    setTimeout(() => {
      const galleryItem = document.querySelector('.gallery-item');
      if (galleryItem) {
        const itemHeight = galleryItem.getBoundingClientRect().height;

        window.scrollBy({
          top: itemHeight * 2,
          left: 0,
          behavior: 'smooth',
        });
      }
    }, 100);
  } catch (error) {
    console.log(error);
    iziToast.error({
      title: 'Error',
      message: 'Something went wrong. Please try again later!',
      position: 'topRight',
      timeout: 2000,
    });
  } finally {
    hideLoader();
  }
}

loadMoreBtn.addEventListener('click', handleLoadMoreClick);
